import $ from 'jquery';
import _ from 'lodash';
import Constants from '../../../common/Constants';
import { BetTypeGroup, PERIOD_STATUS, TENNIS_SERVING, UPDATE_TENNIS_LIVE_SCORE} from '../../../common/Foundation';
import { generateTennisScoreDetail } from '../../../common/template/OddsPageTemplates/TemplateHelper';
import i18next from 'i18next';

export default class MbOddsDataActions {

  /**
   * Handle updating odd changes
   * 
   * @param {*}  
   * @param {*} listOdds 
   * @param {*} options 
   */
  static updateOddsChange($odds, listOdds,options) {
    const jLength = listOdds && listOdds.length;
    const { oddsFormat} = options;
    for (let j = 0; j < jLength; j++) {
      const data = listOdds[j][1];
      const sportId = listOdds[j][0];
      const iLength = data.length;
      //ID: EventId|PeriodNum|BetType|SelectionType|isAltLine[|Handicap]
      for (let i = 0; i < iLength; i++) {
        const u = data[i];
        const action = u[u.length - 2];
        if (action === 0) {
          // Odds update
          let oid = [
            u[u.length - 1], //EventId
            u[0], //PeriodNum
            u[1], //BetType
            u[2], //SelectionType
            u[8] ? 1 : 0 //isAltLine
          ].join('|');
          oid = oid + "|" + (u[3] || 0);
          let a = document.getElementById(oid);
          if (a) {
            const $a = $(a);
            $a.data("oddsid", u[6]);
            $a[0].dataset.oddsid = u[6]

            if (u[5] && $a.text() != u[5] && u[9] == 0) {
              u[9] = u[5] > $a.text() ? 1 : -1;
            }
            if (u[9] !== 0) {
              let newOdds = (oddsFormat === 0 && u[5] > 0) ? '+' + u[5] : u[5].formatSeparators();
              $a.data("odds", newOdds);
              $a[0].dataset.odds = newOdds

              $a.removeClass("up down blinking").removeClass("fav sm")
                .addClass(u[5] < 0 ? 'fav' : '')
                .find("h4").text(newOdds);
              if (u[10] !== 'H') {
                $a.addClass(u[9] > 0 ? "up blinking" : "down blinking");
              }
              $odds.push(a);
            }
          }
        } else if (action === 8) {
          // Update event status    
          const e = $(document).find(`.event#e${u[u.length - 1]}`);
          $(e).removeClass("status_O status_I status_H").addClass("status_" + u[0]);
        } else if (action === 9) {
          // Update Time
          if (u[0]) {
            const $time = $(document).find(`#e${u[u.length - 1]} .liveTm`);
            
            let tm = this.getRunningPeriods(u[0], sportId);
            if (u[1]) {
              tm = `${tm} ${u[1]}`;
            }
            $time.text(tm);
          }
        } else if (action === 10) {
          // Update Score
          if (u[0]) {
              if (sportId === Constants.TENNIS_ID) {
                const liveScoreInfo = u[0].split(",")
                const servingClazz = liveScoreInfo[UPDATE_TENNIS_LIVE_SCORE.SERVING] === TENNIS_SERVING.HOME ? "home" : "away";
                const $teamContainer = $(document).find(`#e${u[u.length - 1]} .team`);
                const $score = $teamContainer.find('.score-detail');
                const $servingTeam = $teamContainer.find(".serving");
                $servingTeam.removeClass("home away");
                $servingTeam.addClass(servingClazz);
                $score.html(generateTennisScoreDetail(liveScoreInfo, true));
              } else {
                const $score = $(document).find(`#e${u[u.length - 1]} .score-detail`);
                $score.text(u[0]);
              }
          }
        } else if (action === 13) {
          // Update period status
          const periodNum = u[1];
          const currentStatus = PERIOD_STATUS.filter(status => status !== `status_${u[0]}`).join("");
          if (u[0]) {
            let e
            if (options.sportId === Constants.TENNIS_ID && (options.betTypeGroup === BetTypeGroup.ML_1X2 || options.betTypeGroup === BetTypeGroup.TEAM_TOTAL)) {
              e = document.querySelectorAll(".event[data-period= '" + periodNum + "'] div[data-eventid='" + u[u.length - 1] + "']")
            } else {
              e = document.querySelectorAll(".event#e" + u[u.length - 1] + " div[data-period ='" + periodNum + "']");
            }
            let $e = $(e)
            $e.removeClass(currentStatus).addClass("status_" + u[0]);
          }
        }
      }
    }
  }

  static getRunningPeriods(rawRunningPeriod, sportId) {
    if (!rawRunningPeriod) return '';
    const runningPeriodArr = rawRunningPeriod.split("-");
    const translatedKey = `periods_${sportId}_${runningPeriodArr[1] || runningPeriodArr[0]}`;
    const translation = i18next.t(`periods:${translatedKey}`);
    return translation !== translatedKey ?
      translation :
      i18next.t(`periods:${runningPeriodArr[1] || runningPeriodArr[0]}`)
  }

  /**
   * Handle checking more bets
   * 
   * @param {*} moreBet 
   */
  static checkMoreBet(oddsPage, moreBet) {
    const rowId = '#e' + moreBet.id + '_more';
    $(oddsPage).find(rowId).addClass('show');
    $(oddsPage).find('#more_' + moreBet.id).addClass('showMore');
    const locMoreBets = $(oddsPage).find(rowId + '.more-bets');
    if (locMoreBets.length > 0) {
      const moreBetContent = locMoreBets.html();
      if (moreBetContent && moreBetContent.trim() !== '') {
        moreBet.content = moreBetContent;
      } else {
        locMoreBets.html(moreBet.content);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/MainComponent/AsiaView/MbOddsDataActions.js